import { push } from 'connected-react-router'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { 
    APPLICATION_MODE_NEW, 
    LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION, 
    ROUTE_PATH 
} from '../../app/constants'
import { replaceUrlParams } from '../../app/utils'
import { Button, Paragraph } from '../../components/RegularComponents'
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils';

export const MLPaymentConfirmation = () => {

    const dispatch = useDispatch()
    const { licencingSubType } = useSelector((state) => ({
        licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
    }));

    const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
    const applicationMode = APPLICATION_MODE_NEW

    const whatHappensNextString = `It will take up to 10 business days to process your licence application. Business Licensing at Service Nova Scotia
                                    and Internal Services will contact you if any additional information is required. Once your licences are approved,
                                    you will receive an email notification to invite you to return to this service to view your licence.`
    const changeSomethingString = `If you have to change information to your submitted applications, contact Business Licensing at <a href="mailto:mortgageregulation@novascotia.ca">mortgageregulation@novascotia.ca</a>`
    const managingApplicationString = `Continue to the service home page to see your application status. 
                                        Once your application is approved, you can download a PDF copy of your licence from the home page.`

    return (
    <div className="container">
        <div className="row topMarginNormal">
            <h1>
                <span className="has-success" style={{marginRight: "5px"}}>
                    <i className="fa fa-check-circle"/>
                </span>
                Your application was submitted for review
            </h1>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <h3>What happens next:</h3>
                <Paragraph 
                    id="payment-confirmation-what-happens-next-para"
                    text={[whatHappensNextString]}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <h3>How to change something on an application you submitted:</h3>
                <Paragraph 
                    id="payment-confirmation-change-something-para"
                    text={[changeSomethingString]}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <h3>Managing your applications and licences online:</h3>
                <Paragraph 
                    id="payment-confirmation-manage-applications-para"
                    text={[managingApplicationString]}
                />
            </div>
        </div>

        <div className="row topMarginMedium">
            <div className="col-lg-2">
                <Button 
                    id="payment-confirmation-go-home-button"
                    buttonType="regular_primary"
                    text="Go to home page"
                    onClick={() => {
                        dispatch(push(replaceUrlParams(
                            ROUTE_PATH.WELCOME, 
                            applicationType, 
                            applicationMode
                        )))
                    }}
                />
            </div>
        </div>
    </div>
    )
}